<div [ngClass]="size">
  <!-- Show + button if allowed -->
  <ng-container *ngIf="showPlusButton(); else infoOnly">
    <!-- Show quantity display when there are any items -->
    <div class="offer-actions" *ngIf="getQuantity() > 0">
      <!-- Show full controls (-, quantity, +) when exactly one cart item (same variant) -->
      <ng-container *ngIf="cartItems?.length == 1">
        <div
          class="icon-button container-theme-light-icons decrement"
          [attr.data-testid]="'offer-actions-decrement-' + offer.offerId"
          (click)="onDecreaseItemQty($event)"
          title="click to decrease quantity"
        >
          <app-icon icon="fa fa-minus m-auto"></app-icon>
        </div>
        <div class="offer-quantity" title="total quantity">
          {{ getQuantity() }}
        </div>
        <div
          class="icon-button container-theme-light-icons increment"
          [ngClass]="{ disabled: isIncreaseQtyDisabled() }"
          [attr.data-testid]="'offer-actions-increment-' + offer.offerId"
          (click)="
            currentCartStatus === 'LOADED' && onOneClickAddToCart($event)
          "
          title="click to add more"
        >
          <app-icon icon="fa fa-plus m-auto"></app-icon>
        </div>
      </ng-container>

      <!-- Show only quantity number when multiple variants (no +/- buttons) -->
      <ng-container *ngIf="cartItems?.length > 1">
        <div
          class="offer-quantity-only"
          title="total quantity for all variants"
        >
          {{ getQuantity() }}
        </div>
      </ng-container>
    </div>

    <!-- No items in cart -->
    <div
      class="icon-clickable-area"
      (click)="currentCartStatus === 'LOADED' && onOneClickAddToCart($event)"
      *ngIf="!cartItems?.length || getQuantity() == 0"
      [ngClass]="{
        'offer-image-action': offer.standardImage,
        'offer-no-image-action': !offer.standardImage,
        'admin-order-capture': isAdminOrderCaptureUpdate,
      }"
      [title]="'public.checkout.addToClick' | translate"
    >
      <div
        class="icon-button container-theme-light-icons add-button"
        [attr.data-testid]="'offer-actions-add-' + offer.offerId"
      >
        <i class="fa fa-plus m-auto plus-icon-catalog"></i>
      </div>
    </div>
  </ng-container>

  <!-- Info icon for menu-only or inactive -->
  <ng-template #infoOnly>
    <div
      class="icon-clickable-area"
      (click)="currentCartStatus === 'LOADED' && onInfoIconClick($event)"
      *ngIf="shouldShowInfoIcon()"
      [ngClass]="{
        'offer-image-action': offer.standardImage,
        'offer-no-image-action': !offer.standardImage,
        'admin-order-capture': isAdminOrderCaptureUpdate,
      }"
      [title]="'public.checkout.clickToDetails' | translate"
    >
      <div class="icon-button container-theme-light-icons">
        <app-icon icon="fa fa-info m-auto"></app-icon>
      </div>
    </div>
  </ng-template>
</div>
